<div class="error-container">
    <div class="text-center">
        <mat-icon class="icon-display">error_outline</mat-icon>
        <h1>404</h1>
        <p>Страница не найдена</p>
        <button routerLink="/" mat-flat-button class="mt-4">На главную</button>
    </div>
</div>